/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TopFund } from './TopFund';
import {
    TopFundFromJSON,
    TopFundFromJSONTyped,
    TopFundToJSON,
} from './TopFund';

/**
 * 
 * @export
 * @interface TopFundsViewModel
 */
export interface TopFundsViewModel {
    /**
     * 
     * @type {Array<TopFund>}
     * @memberof TopFundsViewModel
     */
    topFunds: Array<TopFund>;
}

/**
 * Check if a given object implements the TopFundsViewModel interface.
 */
export function instanceOfTopFundsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "topFunds" in value;

    return isInstance;
}

export function TopFundsViewModelFromJSON(json: any): TopFundsViewModel {
    return TopFundsViewModelFromJSONTyped(json, false);
}

export function TopFundsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopFundsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'topFunds': ((json['TopFunds'] as Array<any>).map(TopFundFromJSON)),
    };
}

export function TopFundsViewModelToJSON(value?: TopFundsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'TopFunds': ((value.topFunds as Array<any>).map(TopFundToJSON)),
    };
}

